/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PendingPaymentPollDto
 */
export interface PendingPaymentPollDto {
    /**
     * 
     * @type {number}
     * @memberof PendingPaymentPollDto
     */
    pendingPaymentId: number;
    /**
     * 
     * @type {string}
     * @memberof PendingPaymentPollDto
     */
    locationId: string;
    /**
     * 
     * @type {string}
     * @memberof PendingPaymentPollDto
     */
    paymentMethodId: string;
    /**
     * 
     * @type {string}
     * @memberof PendingPaymentPollDto
     */
    orderReference: string;
    /**
     * 
     * @type {number}
     * @memberof PendingPaymentPollDto
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof PendingPaymentPollDto
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingPaymentPollDto
     */
    state?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PendingPaymentPollDto
     */
    askForTip: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PendingPaymentPollDto
     */
    createdUtc: Date;
    /**
     * 
     * @type {Date}
     * @memberof PendingPaymentPollDto
     */
    updatedUtc: Date;
}

/**
 * Check if a given object implements the PendingPaymentPollDto interface.
 */
export function instanceOfPendingPaymentPollDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pendingPaymentId" in value;
    isInstance = isInstance && "locationId" in value;
    isInstance = isInstance && "paymentMethodId" in value;
    isInstance = isInstance && "orderReference" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "askForTip" in value;
    isInstance = isInstance && "createdUtc" in value;
    isInstance = isInstance && "updatedUtc" in value;

    return isInstance;
}

export function PendingPaymentPollDtoFromJSON(json: any): PendingPaymentPollDto {
    return PendingPaymentPollDtoFromJSONTyped(json, false);
}

export function PendingPaymentPollDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PendingPaymentPollDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pendingPaymentId': json['pendingPaymentId'],
        'locationId': json['locationId'],
        'paymentMethodId': json['paymentMethodId'],
        'orderReference': json['orderReference'],
        'amount': json['amount'],
        'deviceId': !exists(json, 'deviceId') ? undefined : json['deviceId'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'askForTip': json['askForTip'],
        'createdUtc': (new Date(json['createdUtc'])),
        'updatedUtc': (new Date(json['updatedUtc'])),
    };
}

export function PendingPaymentPollDtoToJSON(value?: PendingPaymentPollDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pendingPaymentId': value.pendingPaymentId,
        'locationId': value.locationId,
        'paymentMethodId': value.paymentMethodId,
        'orderReference': value.orderReference,
        'amount': value.amount,
        'deviceId': value.deviceId,
        'state': value.state,
        'askForTip': value.askForTip,
        'createdUtc': (value.createdUtc.toISOString()),
        'updatedUtc': (value.updatedUtc.toISOString()),
    };
}

